var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"auth-layout__content",class:{ 'm-wide': _vm.isWide }},[_vm._t("default")],2),_c('div',{staticClass:"auth-layout__actions"},[(_vm.hasLogout)?_c('LogoutButton'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }